import Group from './Group'

export default class GroupCollection extends Array {

	constructor (groupsData, elementsData = []) {
		super()

		const elementsMap = new Map()
		elementsData.forEach(elementData => {
			if (elementsMap.has(elementData.group_id)) {
				elementsMap.get(elementData.group_id).push(elementData)
			} else {
				elementsMap.set(elementData.group_id, [elementData])
			}
		})

		groupsData.forEach(groupData => {
			this.push(new Group(groupData, elementsMap.get(parseInt(groupData.id))))
		})
	}
}



// WEBPACK FOOTER //
// ./src/classes/GroupCollection.js